import { DisruptionNotificationEnum, DisruptionNotificationGracePeriodEnum } from 'src/graphql/schema';

export const getDisruptionNotificationGracePeriod = ({
  disruptionNotification,
  newDisruptionNotificationGracePeriod,
  oldDisruptionNotificationGracePeriod,
}: {
  disruptionNotification: DisruptionNotificationEnum;
  newDisruptionNotificationGracePeriod: DisruptionNotificationGracePeriodEnum | undefined | null;
  oldDisruptionNotificationGracePeriod: DisruptionNotificationGracePeriodEnum | undefined | null;
}) => {
  if (disruptionNotification !== DisruptionNotificationEnum.SendNotification) return;

  return newDisruptionNotificationGracePeriod ?? oldDisruptionNotificationGracePeriod;
};
